export const columnsDataComplex = [
  {
    Header: "COUPON CODE",
    accessor: "couponCode",
  },
  {
    Header: "COUPON VALUE",
    accessor: "value",
},
  {
    Header: "DATE",
    accessor: "redeemedAt",
  },
];
